import { useParams } from 'react-router-dom'
import { PaperworkRuntime } from 'app/components/form-runtime/PaperworkRuntime'

export default function PaperworkRuntimePage() {
  const { token } = useParams<{ token: string }>()
  return <PaperworkRuntime token={token} />
}
